const footerLinksFn = (root, storybookRoot) => {
  const toggleBtn = root.querySelectorAll(".mdn-FooterLinks-column-toggler");
  if (!toggleBtn) return;

  toggleBtn.forEach(btn => {
    btn.onclick = () => {
      btn.classList.toggle("is-expanded");
      btn.setAttribute("aria-expanded", `${(btn.getAttribute("aria-expanded") !== "true")}`);
    };
  });

  return storybookRoot ? storybookRoot : root;
};


export default footerLinksFn;
